import script from "./cooperation.vue?vue&type=script&setup=true&lang=js"
export * from "./cooperation.vue?vue&type=script&setup=true&lang=js"

import "./cooperation.vue?vue&type=style&index=0&id=0389b1b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0389b1b0"]])

export default __exports__